import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
  const featuredArticles = articles.filter((a) => a.isFeatured);
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  ).slice(0, 6);

  return (
    <>
      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '爱情岛论坛亚洲 - 首页',
            url: 'https://www.aiqingdao.com/',
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: latestArticles.map((article, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                  '@type': 'Article',
                  name: article.title,
                  url: `https://www.aiqingdao.com/article/${article.slug}`,
                },
              })),
            },
          }),
        }}
      />

      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20romantic%20abstract%20geometric%20composition%20with%20soft%20pink%20rose%20cream%20and%20peach%20gradients%2C%20flowing%20organic%20shapes%2C%20gentle%20atmospheric%20mood%2C%20minimal%20artistic%20style%2C%20dreamy%20ethereal%20quality&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="爱情岛论坛亚洲 - 亚洲最热情感交流社区"
          title="爱情岛论坛亚洲"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            爱情岛论坛亚洲
          </h1>
          <p className="text-base md:text-lg text-white/90 max-w-2xl leading-relaxed mb-6">
            亚洲最热情感交流社区，汇聚海量恋爱经验分享、婚恋话题讨论与情感咨询资源
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/lianai-jiqiao"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-white text-sm font-medium hover:bg-background-50/30 transition-all cursor-pointer whitespace-nowrap border border-white/30"
            >
              了解更多
            </Link>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
          <i className="ri-arrow-down-line text-white/60 text-2xl animate-bounce"></i>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              探索情感话题
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              选择你感兴趣的分类，找到最适合你的情感内容
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 transition-all cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-600`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500">{cat.count}篇</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <Link
              to="/category/lianai-jiqiao"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {featuredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-full sm:w-[200px] h-[180px] sm:h-[140px] flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 爱情岛论坛亚洲`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i> {article.likes}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i> {article.comments}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Hot Articles */}
      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-fire-line text-accent-600"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                热门文章
              </h2>
            </div>
            <Link
              to="/category/lianai-jiqiao"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {hotArticles.map((article, index) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col rounded-xl bg-background-100 hover:bg-background-200 transition-colors overflow-hidden cursor-pointer"
              >
                <div className="relative h-[180px] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 爱情岛论坛亚洲`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-accent-500 text-background-50 whitespace-nowrap">
                      #{index + 1}
                    </span>
                  </div>
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 self-start mb-2 whitespace-nowrap">
                    {article.category}
                  </span>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2 flex-1">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i> {article.comments}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="w-full max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">
            最新文章
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col rounded-xl bg-background-50 hover:bg-background-100 transition-colors overflow-hidden cursor-pointer"
              >
                <div className="h-[180px] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 爱情岛论坛亚洲`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2 flex-1">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full overflow-hidden bg-background-200">
                        <img src={article.authorAvatar} alt={article.author} className="w-full h-full object-cover" />
                      </span>
                      {article.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i> {article.likes}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 md:py-20 px-4 md:px-6 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20romantic%20abstract%20gradient%20composition%20with%20warm%20peach%20cream%20and%20rose%20pastel%20tones%2C%20flowing%20organic%20curves%2C%20gentle%20ethereal%20atmosphere%2C%20dreamy%20minimal%20style&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/25"></div>
        <div className="relative z-10 w-full max-w-7xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            加入爱情岛论坛，开启你的情感之旅
          </h2>
          <p className="text-sm md:text-base text-white/85 max-w-xl mx-auto mb-6 leading-relaxed">
            无论你正在寻找爱情建议、分享感情故事，还是结交志同道合的朋友，这里都是你的首选社区
          </p>
          <button className="px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap">
            立即加入
          </button>
        </div>
      </section>
    </>
  );
}